import gql from 'graphql-tag';

export const getProceduresByStudent = gql`
  query getProceduresByStudent {
    procedures {
      requests {
        id
        procedureId
        name
        status {
          status
          name
          description
        }
        duration
        createdDate
        startDate
        estimatedEndDate
        realEndDate
      }
    }
  }
`;

export const getProcedureInformation = gql`
  query getProcedureInformation($procedureId: Float!, $studentType: String) {
    procedures {
      procedure(procedureId: $procedureId, studentType: $studentType) {
        id
        amount
        duration
        name
        steps {
          id
          name
          order
        }
        model
        requirements
        periodRelativeCP
        pin1
        pin2
        moreInfo
        currentRequestId
        isValidatedStudentFoto
        requestInProgress
        disabled
        endDate
        text1
        enrollment
        requestLimit
        enrolledCourses
        stepsToFollow
        deliverySchedule
        hasPhoto
        isValidatedStudentFoto
        isProvince
        isEntering
        isReincorporated
        isprocessFinished
        isEnrolledInCoursesM1 # Campo innecesario para validación, se está coordinando su eliminación
        hasFinishedCourses
        districts {
          id
          name
        }
        reasons
        periods {
          id
          description
          hasDebts
        }
        error {
          title
          description
        }
        detail {
          rectificationReasons {
            id
            name
          }
          coursesToRectification {
            campusName
            campusCode
            career
            catalog
            courseName
            professorId
            professorName
            section
            matter
            module
          }
          employabilityCharters {
            id
            description
            studentType
          }
          enrolledCourses {
            id
            name
            classId
            courseId
            CodigoEstado
          }
          hasScholarship
          datesModule {
            name
            deadlineWithRecalc
            deadlineWithoutRecalc
          }
          relatedCourses {
            courses {
              id
              name
              classId
              courseId
            }
          }
          periodApplied {
            id
            name
          }
          studiesOptionList {
            id
            name
            tag
          }
          campusApplied {
            id
            name
          }
          applySince
          periodId
          periodDesc
          program
          weightedAverage
          hasDebts
          modalityList {
            id
            name
          }
          currentAcademicData {
            program {
              id
              name
            }
            campus {
              id
              name
            }
            modality {
              id
              name
            }
            grouping {
              id
              name
            }
            studiesOption {
              careerName
              modalityName
              careerCode
              modalityCode
            }
          }
          communicationRange {
            id
            name
          }
        }
      }
    }
  }
`;

export const getProcedureRequestDetail = gql`
  query getProcedureRequestDetail($procedureId: Float!, $requestId: Float!) {
    procedures {
      requestDetail(procedureId: $procedureId, requestId: $requestId) {
        procedure {
          id
          amount
          duration
          name
          requirements
          steps {
            id
            name
            order
            isComplete
            isCurrent
            date
          }
          stepsToFollow
          deliverySchedule
          pin1
          pin2
          moreInfo
          endDate
          text1
          detail {
            period
            isAutomatic
            isMigrated
            course
            test
            destinationCampus
            applySince
            periodId
            periodDesc
            program
            campus
            contacto
            weightedAverage
            hasDebts
            deliveryMode
            district
            enrolledCourses {
              id
              name
              classId
              courseId
            }
            currentAcademicData {
              program {
                id
                name
              }
              campus {
                id
                name
              }
              modality {
                id
                name
              }
              studiesOption {
                careerName
                careerCode
                modalityName
                modalityCode
              }
            }
            newAcademicData {
              program {
                id
                name
              }
              campus {
                id
                name
              }
              modality {
                id
                name
              }
              shift
              shiftDesc
              studiesOption {
                careerName
                careerCode
                modalityName
                modalityCode
              }
            }
            employabilityCharterDetail {
              charterDesc
              companyName
              representative
              position
              duration
              documentPath
            }
            rectificationOfGradesDetail {
              commentary
              course
              evaluation
              currentGrade
              newGrade
              reasonName
              requestDate
              responseDate
              probableDateOfAttention
            }
            removeFromPeriodDetail {
              reason
              contact
              requestDate
              responseDate
              probableDateOfAttention
              bussinessHour
            }
            certificateDetail {
              beneficiaryId
              beneficiaryName
              documentCount
              requestDate
              responseDate
              probableDateOfAttention
            }
            periodReincorporated
          }
        }
        request {
          id
          procedureId
          name
          amount
          requiresPayment
          payed
          status {
            status
            name
            description
          }
          duration
          comentary
          document
          expiredFile
          statusBse {
            status
            activatedPayment
            payed
          }
        }
      }
    }
  }
`;

export const getProceduresCategory = gql`
  query getProceduresCategory {
    procedures {
      categories {
        procedureId
        category
        type
        endDate
        name
        isExternal
        availableInApp
      }
    }
  }
`;

export const getStudentInformation = gql`
  query getStudentInformation {
    student {
      procedureInfo {
        firstName
        lastName
        code
        faculty
      }
    }
  }
`;

export const getCampusByModality = gql`
  query getCampusByModality($modalityId: String!) {
    procedures {
      campusByModality(modalityId: $modalityId) {
        id
        name
      }
    }
  }
`;

export const getProgramByCampus = gql`
  query getProgramByCampus($campusId: String!, $modalityId: String!) {
    procedures {
      programByCampus(campusId: $campusId, modalityId: $modalityId) {
        id
        name
      }
    }
  }
`;

export const getProceduresNotAutomated = gql`
  query getProceduresNotAutomated {
    procedures {
      proceduresNotAutomated(isSelfManaged: false) {
        id
        name
      }
    }
  }
`;

export const getProceduresCreated = gql`
  query getStudenProceduresByYear($year: String!) {
    procedures {
      requestByYear(year: $year) {
        procedureId
        requestId
        type
        name
        status {
          status
          name
          description
        }
        startDate
        endDate
        estimatedEndDate
        realEndDate
        createdDate
      }
    }
  }
`;

export const getYearsOfProcedures = gql`
  query getYearsOfProcedures {
    procedures {
      years
    }
  }
`;

export const registerTicketNotAutomated = gql`
  mutation registerTicketCRM($request: registerTicketCRMRequest!) {
    registerTicketCRM(request: $request) {
      ticketId
      days
    }
  }
`;

export const registerCarnet = gql`
  mutation registerCarnet($request: RegisterCarnetRequest!) {
    registerCarnet(request: $request) {
      requestId
      status
    }
  }
`;

export const activateRegisterCarnet = gql`
  mutation activateCertificateType01(
    $procedureId: Float!
    $requestId: Float!
    $deliveryMode: String!
    $career: String!
  ) {
    activateCertificateOfStudiesProcedure(
      requestId: $requestId
      procedureId: $procedureId
      deliveryMode: $deliveryMode
      career: $career
    ) {
      error
      requestId
    }
  }
`;

export const cancelRegisterCarnet = gql`
  mutation cancelRegisterCarnetData($procedureId: Float!, $requestId: Float!) {
    cancelRequestProcedure(requestId: $requestId, procedureId: $procedureId) {
      error
      requestId
    }
  }
`;

export const getModalityOptionList = gql`
  query getModalityOptionList($campus: String!, $periodId: Float!) {
    procedures {
      modalityOptionList(campus: $campus, periodId: $periodId) {
        id
        name
        tag
        grado
        plan
        period
        campus
        shifts {
          id
          name
        }
      }
    }
  }
`;

export const registerChangePhoto = gql`
  mutation registerChangePhoto(
    $imgBase64: String!
    $type: String!
    $period: String!
  ) {
    updatePhoto(imgBase64: $imgBase64, type: $type, period: $period) {
      error
      requestId
    }
  }
`;

export const registerEmployabilityCharter = gql`
  mutation registerEmployabilityCharter(
    $request: RegisterEmployabilityCharterRequest!
  ) {
    registerEmployabilityCharter(request: $request) {
      error
      requestId
    }
  }
`;

export const getPeriodsWithDebts = gql`
  query getPeriodsWithDebts($currentPeriod: String!) {
    procedures {
      periodsWithDebts(currentPeriod: $currentPeriod)
    }
  }
`;
